import { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";

export default function NotepadLayout() {
    const paramsData = useParams();

    const notepadId = paramsData?.id === "notedrop" ? "" : paramsData?.id;

    useEffect(() => {
        document.title = `NoteDrop ${notepadId ? "- " + notepadId : ""} | Nithin P B`;

        return () => {
            document.title = "NoteDrop | Nithin P B";
        };
    }, [paramsData.id]);
    return (
        <div className="w-full h-full" style={{ background: "var(--fq-page-bg)", transition: "background 0.4s ease" }}>
            <Outlet />
        </div>
    );
}
